export const environment = {
  production: false,
  baseUrl: 'https://api-dev.halcyonsign.com',
  apiKey: "fc0ea374b67a4d0a8a805d5f8dd37122",
  clientId: '93fe685f-efe5-4204-96e6-753fb4679f82',
  resourceId: 'api://63d0d8e7-fed0-408a-b155-72042954c38e/Read'
};